<div class="td-cnt-ext" [style.top.px]="top">
    <div class="td-cnt" [ngClass]="{'td-cnt-mobile' : isMobile}" id="teiasoftDialog">
        <div class="td-cnt-title">
            <div>
                <i class="{{dialogIcon}} dialog-icon"></i>
                <span class="te-title">{{title}} <span *ngIf="urloToDownload && urloToDownload.length > 0">({{urloToDownload.length}} {{'commons.filesSelected' | translate}})</span></span>
            </div>
        </div>
        <div class="td-cnt-body">
            <teiasoft-grid style="margin-top: 1vh;width:100%"
                [dataSet]="attachments"
                [showFooter]="false"
                [selectable]="false"
                [theme]="theme"
                [autoWidth]="true"
                [showEditIcon]="false"
                [dateFormat]="globals.dateFormat!"
                [dateTimeFormat]="globals.dateTimeFormat!" 
                [columnsToHide]="columnsToHide"
                [sortable]="false"
                [selectable]="true"
                [multiSelection]="true"
                [disableAllSelection]="false"
                (rowsSelected)="rowsSelected($event)"
                [minWidthVw]="40"
                [columnsToShow]="['fileDate','fileName']"
            ></teiasoft-grid> <!-- [minWidthVw]="27" -->
            <!-- <div class="preview-cnt">
                <div style="width: 100%;">
                    <span class="bold" style="font-size: 2.4vh;"><i class="fal fa-paperclip mr-5"></i>{{'commons.preview' | translate}}</span>
                </div>
                <span class="no-data" style="width: 100%; margin-left:0! important; margin-top: 5vh;text-align: center;">{{'commons.noPreview' | translate}}</span>
                <object [data]="safeDocumentUrlBlob" [type]="documentType" width="100%" height="100%" style="display: none;" 
                    [ngClass]="{'show-me' : (documentType.startsWith('text/')) || documentType == 'application/pdf'}">
                    <p>Unable to open the file {{safeDocumentUrlBlob}}</p>
                </object>
            </div> -->



             <!-- PDF, TEXT PLAIN, HTML -->
<!--              <object [data]="safeDocumentUrlBlob" [type]="documentType" width="100%" height="100%" style="display: none;" 
             [ngClass]="{'show-me' : (documentType.startsWith('text/')) || documentType == 'application/pdf'}">
             <p>Unable to open the file {{safeDocumentUrlBlob}}</p>
            </object> -->

            <!-- IMAGES -->
   <!--          <img style="display: none;" [src]="documentType" [ngClass]="{'show-me' : (ext == 'jpg' || ext == 'jpeg' || ext == 'png' || ext == 'svg' || ext == 'gif' || ext == 'tiff')}"> -->

            <!-- VIDEO -->
<!--             <video controls id="videoPlayer" x-webkit-airplay="allow" preload="" style="display: none;"  [ngClass]="{'show-me' : (ext == 'mp4' || ext == 'mov')}">
                <source  [type]="documentType">
            </video> -->

            <!-- AUDIO -->
<!--             <audio id="audioPlayer" controls style="display: none;"  [ngClass]="{'show-me' : (ext == 'mp3' || ext == 'wav')}"></audio> -->
            
        </div>
        <div class="td-cnt-btn" [ngClass]="{'td-cnt-btn-mobile' : isMobile}">
            <teiasoft-button (onClick)="onDownloadAttach()" class="mr-5" [type]="'tb-primary'" [disabled]="!urloToDownload || urloToDownload.length == 0"
                [text]="'commons.donwload' | translate" [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
            <teiasoft-button (onClick)="onCloseModalClick()" [type]="'tb-cancel'" [text]="'commons.cancel' | translate"
                [theme]="theme" [isMobile]="isMobile"></teiasoft-button>
        </div>
    </div>
</div>
